export const formatFileSize = (size, insetedStr = "") => {
  if (!size) return "0 KB";
  return size > 1024 ? (size / 1024).toFixed(2) + " MB" : size + " KB";
};
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time) {
  var dt = new Date(time);

  const Y = dt.getFullYear();
  const M = (dt.getMonth() + 1).toString().padStart(2, "0");
  const D = dt.getDate().toString().padStart(2, "0");
  const hh = dt.getHours().toString().padStart(2, "0");
  const mm = dt.getMinutes().toString().padStart(2, "0");
  const ss = dt.getSeconds().toString().padStart(2, "0");

  return `${Y}-${M}-${D} ${hh}:${mm}:${ss}`;
}
